document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".sticky-atc-bar.hidden");
  const badges = document.querySelector(".product__primary-right .product-badges"); 
  const mainProduct = document.querySelector(".main-product-section"); 
  const mediaContainer = document.querySelector(".product__media-container"); 
  const recommended = document.querySelector(".recommended-products"); 
  const backToTop = document.querySelector(".back-to-top");
  const drawer = document.querySelector(".shoppable-feature-mobile-drawer");

  // --- Coming Soon Logik (Detailseite) ---
  const comingSoonElement = document.querySelector('[data-handle="coming-soon"]');
  if (comingSoonElement) {
    const cartButtons = document.querySelectorAll(".product-form__cart-submit");
    cartButtons.forEach(btn => {
      btn.disabled = true;
      btn.classList.add("disabled");
      //const metaValue = btn.getAttribute("aria-label");
      //btn.textContent = metaValue;
    });

    if (badges) {
      badges.style.display = "none"; // sofort verstecken
    }
  }

  // --- Quick View Coming Soon Logik ---
  document.addEventListener("click", function (e) {
    const quickTrigger = e.target.closest('[data-quick-shop-trigger="quick-view"]');
    if (quickTrigger) {
      setTimeout(() => {
        const quickView = document.querySelector(".quick-product--right");
        if (quickView) {
          const comingSoonBadge = quickView.querySelector('.product-badge[data-handle="coming-soon"]');
          if (comingSoonBadge) {
            const quickViewButtons = quickView.querySelectorAll(".product-form__cart-submit");
            quickViewButtons.forEach(btn => {
              btn.disabled = true;
              btn.classList.add("disabled");
              const metaValue = btn.getAttribute("aria-label");
              btn.textContent = metaValue;
            });
          }
        }
      }, 1000);
    }
  });

  if (!bar && !badges && !backToTop && !drawer) return;

  // --- Scroll-Logik ---
  window.addEventListener("scroll", function () {
    const viewportMiddle = window.innerHeight / 2;
    const isMobile = window.innerWidth < 960;

    if (bar && mainProduct) {
      const rectMain = mainProduct.getBoundingClientRect();
      const shouldHideBar = rectMain.bottom <= viewportMiddle;

      bar.style.transition = "transform 0.3s ease, visibility 0.3s ease";
      if (shouldHideBar) {
        bar.style.transform = "translateY(100%)";
        bar.style.visibility = "hidden";
      } else {
        bar.style.transform = "translateY(0%)";
        bar.style.visibility = "visible";
      }
    }

    if (!comingSoonElement && badges) {
      badges.style.transition = "opacity 0.3s ease";

      if (isMobile && mediaContainer) {
        const rectMedia = mediaContainer.getBoundingClientRect();
        const mediaMiddle = rectMedia.top + rectMedia.height / 2;
        const shouldHideBadges = mediaMiddle <= viewportMiddle;

        badges.style.opacity = shouldHideBadges ? "0" : "1";
        badges.style.pointerEvents = shouldHideBadges ? "none" : "auto";
      } else if (!isMobile && recommended) {
        const rectRec = recommended.getBoundingClientRect();
        const recMiddle = rectRec.top + rectRec.height / 2;
        const shouldHideBadges = recMiddle <= viewportMiddle;

        badges.style.opacity = shouldHideBadges ? "0" : "1";
        badges.style.pointerEvents = shouldHideBadges ? "none" : "auto";
      }
    }
  });

  // --- Beobachten, ob Drawer .active erhält ---
  if (drawer && backToTop) {
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === "class") {
          if (drawer.classList.contains("active")) {
            backToTop.classList.remove("visible");
          } else {
            backToTop.classList.add("visible");
          }
        }
      }
    });
    observer.observe(drawer, { attributes: true });
  }

  // --- Akkordeon Scroll-Logik mit Offset ---
  const accordions = document.querySelectorAll(".accordion__label");
  accordions.forEach(label => {
    label.addEventListener("click", function () {
      const parent = label.closest(".accordion__inner");
      setTimeout(() => {
        if (parent && (parent.classList.contains("open") || label.getAttribute("aria-expanded") === "true")) {
          const rect = parent.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const offset = 100; 
          window.scrollTo({
            top: rect.top + scrollTop - offset,
            behavior: "smooth"
          });
        }
      }, 300);
    });
  });


// --- SVG in Wishlist-Buttons ersetzen ---
function replaceWishlistSVGs(root = document) {
  const selectors = [
    ".wishlisthero-floating.wishlist-hero-custom-button svg",
    "#wishlisthero-product-page-button-container svg"
  ];

  selectors.forEach(sel => {
    const svgs = root.querySelectorAll(sel);
    svgs.forEach(svg => {
      const img = document.createElement("img");
      img.src = "https://cdn.shopify.com/s/files/1/0941/6022/4586/files/hernameis-heart.svg?v=1755716111";
      img.width = 14;
      img.alt = "Herz Icon";
      svg.replaceWith(img);
    });
  });
}

// einmal beim Laden
replaceWishlistSVGs();

// MutationObserver für dynamisch eingefügte Wishlist-Buttons
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      if (
        node.matches?.(".wishlisthero-floating.wishlist-hero-custom-button, #wishlisthero-product-page-button-container")
      ) {
        replaceWishlistSVGs(node);
      }

      if (node.querySelectorAll) {
        replaceWishlistSVGs(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

});